export default __webpack_public_path__ + "static/media/2-StrandedMooring.a394e4fd.jpeg";